import { FilterType } from '../../filters/models/filter-type';
import { ColumnType } from './column-type';

/**
 * Informations sur un filtre.
 */
export class FilterInfos {
    /** Nom du champs sur lequel s'applique le filtre. */
    ColumnName: string;

    /** Valeur à filtrer. */
    Value: string;

    /** type de filtre */
    Type: ColumnType;

    FilterType: FilterType;

    /** Indique s'il s'agit d'une selection multiple */
    SelectionMultiple: boolean;
}
